import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import { readOnly } from '@ember/object/computed';
import { action, computed } from '@ember/object';
import { replace } from '@square/dashboard-utilities/utils/window';
import { generateSavingsAccountUrl } from '@banking/ui/utils/savings-account-url';

export default class SuccessController extends Controller {
  @service currentApplicationFlow;
  @service router;
  @service plaidState;
  @service sfsExternalBankAccountApi;

  @readOnly('currentApplicationFlow.bankcBalanceId')
  bankcBalanceId;

  @computed(
    'plaidState.isLinkLessThanOneDay',
    'sfsExternalBankAccountApi.{hasImportableExternalBankAccounts,hasLinkedExternalBankAccountWithinOneDay}'
  )
  get showPlaidLink() {
    return (
      !this.plaidState.isLinkLessThanOneDay &&
      !this.sfsExternalBankAccountApi
        .hasLinkedExternalBankAccountWithinOneDay &&
      !this.sfsExternalBankAccountApi.hasImportableExternalBankAccounts
    );
  }

  @action
  continue() {
    if (this.showPlaidLink) {
      this.router.transitionTo(
        'signup.link-external-bank-account.link-with-plaid'
      );
    } else {
      this.router.transitionTo(
        'signup.link-external-bank-account.import-bank-account'
      );
    }
  }

  @action
  goToGeneralSavings() {
    const url = generateSavingsAccountUrl(this.bankcBalanceId);
    replace(url);
  }
}
